// extracted by mini-css-extract-plugin
module.exports = {"container":"OnboardingIntro_container__r-pLR","introText":"OnboardingIntro_introText__2pDUB","title":"OnboardingIntro_title__1GR99","center":"OnboardingIntro_center__3VFYK"};